import ClassAttendance from '@/api/class-attendance'
import Term from '@/api/term-semester'
import ClassOperation from '@/api/class-operation'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  teacherOrSubjects: [],
  att_by_subject: [],
  attendenStatus: [],
  presentStatus: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_TEACHER_OR_SUBJECT (state, data) {
    state.teacherOrSubjects = data
  },
  SET_ATT_BY_SUBJECT (state, data) {
    state.att_by_subject = data
  },
  SET_ATT_STATUS (state, data) {
    state.attendenStatus = data
  },
  SET_PRESENT_STATUS (state, data) {
    state.presentStatus = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    return ClassAttendance.get({ params: attrubutes }).then(response => {
      return Promise.resolve(response)
    })
  },

  store (context, data) {
    return ClassAttendance.store(data)
  },

  fetchTerms (context) {
    return Term.get({
      params: {
        page: -1,
        fields: {
          academic_terms: 'ac_term_id,term_name'
        },
        filter: {
          ac_status_id: '1'
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchClasses (context, attributes = {}) {
    if (attributes.ac_term_id === undefined || attributes.ac_term_id === null)
      return { data: [] }

    return ClassOperation.get({
      params: {
        page: -1,
        include: 'teacher,academic_study_time',
        fields: {
          academic_classes: 'class_id,class_name,teacher_resp_id,ac_st_id'
        },
        filter: {
          ac_term_id: attributes.ac_term_id
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchTeachers (context, attributes = {}) {
    if (
      attributes.class_id === undefined ||
      attributes.class_id === null ||
      attributes.att_date === undefined ||
      attributes.att_date === null
    )
      return

    return ClassAttendance.getTeachers({ params: attributes }).then(
      response => {
        context.commit('SET_TEACHER_OR_SUBJECT', response.teacher)
        context.commit('SET_ATT_BY_SUBJECT', response.attendance_by_subject)
        return Promise.resolve(response)
      }
    )
  },

  async dataBeforeCreate (context) {
    if (!context.state.attendenStatus.length > 0) {
      let response = await ClassAttendance.getAttendanceStatus()
      context.commit('SET_ATT_STATUS', response.data)
    }
    if (!context.state.presentStatus.length > 0) {
      let response = await ClassAttendance.getPresentStatus()
      context.commit('SET_PRESENT_STATUS', response.data)
    }
  }
}
